import api from './service/api.service';

export const requestToSupportMail = async (data: unknown) => {
  const targetUrl = '/v1/mail/request-support';

  return await api.post(targetUrl, data);
};
